import {Component, EventEmitter, Input, Output} from '@angular/core';

import {KeyPoint} from 'shared/models/questions/keypoint';
import {SliderQuestionType} from 'shared/models/questions/slider-question-type';
import {TranslatedText} from 'shared/models/translated-text';

@Component({
  selector: 'type-slider',
  templateUrl: './type-slider.component.html',
  styleUrls: ['./type-slider.component.css'],
})
export class TypeSliderComponent {

  @Input() public language: string;
  @Input() public showDeleteButton: boolean;
  @Input() public data: SliderQuestionType;
  @Input() public hasSliderTitle: boolean;
  @Input() public inChains: Array<string>;
  @Input() public isSystemQuestion: boolean;
  @Input() public isChainSystemEditable: boolean = false;
  @Output() public dataChange: EventEmitter<SliderQuestionType>;
  @Output() public delete: EventEmitter<void>;

  public oldKeyPointCount: number = null;

  constructor() {
    this.data = new SliderQuestionType(this.hasSliderTitle);
    this.dataChange = new EventEmitter<SliderQuestionType>();
    this.delete = new EventEmitter<void>();
  }

  public addKeyPoint(): void {
    if (this.oldKeyPointCount === null) {
      this.oldKeyPointCount = this.data.keyPoints.length;
    }
    this.data.addKeyPoint();
    this.dataChange.emit(this.data);
  }

  public deleteKeyPoint(index: number): void {
    this.data.deleteKeyPoint(index);
    this.dataChange.emit(this.data);
  }

  public onDelete(): void {
    this.delete.emit();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-slider/type-slider.component.ts